import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../services/api';

const COR_SETOR = {
  'Atendimento':       '#00c9db',
  'Arte Finalista':    '#a78bfa',
  'Pré Produção':      '#fbbf24',
  'Impressão Offset':  '#4f8ef7',
  'Impressão Digital': '#818cf8',
  'Impressão Fora':    '#c084fc',
  'Acabamento':        '#4ade80',
  'Corte':             '#f97316',
  'Expedição':         '#34d399',
};

const TIPOS_IMPRESSAO = ['Impressão Offset', 'Impressão Digital', 'Impressão Fora'];

/* ── Ícone de QR Code / scan ──────────────────────── */
function IconeScan() {
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="3" width="5" height="5" rx="1"/>
      <rect x="16" y="3" width="5" height="5" rx="1"/>
      <rect x="3" y="16" width="5" height="5" rx="1"/>
      <line x1="16" y1="16" x2="16" y2="21"/>
      <line x1="16" y1="16" x2="21" y2="16"/>
      <line x1="21" y1="19" x2="21" y2="21"/>
      <line x1="19" y1="21" x2="21" y2="21"/>
      <line x1="10" y1="3" x2="10" y2="6"/>
      <line x1="3" y1="10" x2="6" y2="10"/>
      <line x1="10" y1="10" x2="10" y2="10"/>
      <line x1="16" y1="10" x2="21" y2="10"/>
      <line x1="10" y1="16" x2="10" y2="21"/>
    </svg>
  );
}

/* ── Ícone check ──────────────────────────────────── */
function IconeCheck() {
  return (
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="20 6 9 17 4 12"/>
    </svg>
  );
}

export default function Bipagem() {
  const [numero, setNumero]         = useState('');
  const [item, setItem]             = useState(null);
  const [fase, setFase]             = useState('idle');
  const [mensagem, setMensagem]     = useState('');
  const [ultimaAcao, setUltimaAcao] = useState('');
  const [escolhendoTipo, setEscolhendoTipo]                         = useState(false);
  const [tipoSelecionado, setTipoSelecionado]                       = useState(null);
  const [destinoDireto, setDestinoDireto]                           = useState(null);
  const [escolhendoProximoSetorFora, setEscolhendoProximoSetorFora] = useState(false);
  const [setorForaSelecionado, setSetorForaSelecionado]             = useState(null);
  const [erroDetalhes, setErroDetalhes]                             = useState(null);
  const inputRef = useRef(null);
  const navigate = useNavigate();

  const usuario  = JSON.parse(localStorage.getItem('usuario') || '{}');
  const isAdmin  = usuario.perfil === 'admin';
  const corSetor = isAdmin ? '#f0a500' : (COR_SETOR[usuario.setor] || '#f0a500');
  const labelSetor = isAdmin ? 'Administrador' : usuario.setor;

  function logout() {
    localStorage.removeItem('token');
    localStorage.removeItem('usuario');
    navigate('/login');
  }

  function resetar() {
    setNumero('');
    setItem(null);
    setFase('idle');
    setMensagem('');
    setErroDetalhes(null);
    setEscolhendoTipo(false);
    setTipoSelecionado(null);
    setDestinoDireto(null);
    setEscolhendoProximoSetorFora(false);
    setSetorForaSelecionado(null);
    setTimeout(() => inputRef.current?.focus(), 50);
  }

  async function buscarItem(e) {
    e.preventDefault();
    if (!numero.trim()) return;

    setFase('buscando');
    setItem(null);
    setMensagem('');

    try {
      const dados = await api.getItem(numero.trim());
      setItem(dados);
      setFase('pronto');
    } catch (err) {
      setMensagem(err.message);
      setFase('erro');
    }
  }

  async function bipar(acao, tipo = null, proximoSetorFora = null, destDireto = null) {
    setFase('bipando');
    setUltimaAcao(acao);

    try {
      const resposta = await api.bipar(numero.trim(), acao, tipo, null, null, null, null, null, proximoSetorFora, destDireto);
      setMensagem(resposta.mensagem);
      setFase('sucesso');
      setTimeout(resetar, 2200);
    } catch (err) {
      setMensagem(err.message);
      setErroDetalhes(err.detalhes || null);
      setFase('erro');
    }
  }

  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  // Auto-dismiss de 5s para qualquer estado de erro
  useEffect(() => {
    if (fase !== 'erro') return;
    const timer = setTimeout(() => {
      setErroDetalhes(null);
      setFase('idle');
      setMensagem('');
    }, 5000);
    return () => clearTimeout(timer);
  }, [fase]);

  const ocupado = fase === 'buscando' || fase === 'bipando';

  return (
    <div style={{ minHeight: '100vh', background: '#0d0d0d', display: 'flex', flexDirection: 'column' }}>

      {/* ── Header ──────────────────────────────────── */}
      <header style={{
        background: '#111',
        borderBottom: '1px solid #1a1a1a',
        padding: '0 1.5rem',
        height: '58px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexShrink: 0,
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <div style={{
            width: '36px', height: '36px', background: '#f0a500',
            borderRadius: '7px', display: 'flex', alignItems: 'center',
            justifyContent: 'center', flexShrink: 0,
          }}>
            <span style={{ fontFamily: "'Bebas Neue', cursive", color: '#0d0d0d', fontSize: '15px' }}>GM</span>
          </div>
          <div>
            <p style={{ fontFamily: "'Bebas Neue', cursive", fontSize: '1.05rem', color: '#e0e0e0', letterSpacing: '0.06em', margin: 0, lineHeight: 1 }}>
              GRÁFICA MÁXIMA
            </p>
            <p style={{ fontFamily: "'DM Sans', sans-serif", fontSize: '0.72rem', color: '#555', margin: 0, marginTop: '3px' }}>
              Bipagem de itens
            </p>
          </div>
        </div>

        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <div style={{ textAlign: 'right' }}>
            <p style={{ fontFamily: "'DM Sans', sans-serif", fontSize: '0.84rem', color: '#c0c0c0', fontWeight: 500, margin: 0, lineHeight: 1 }}>
              {usuario.nome}
            </p>
            {usuario.setor && (
              <p style={{
                fontFamily: "'DM Sans', sans-serif",
                fontSize: '0.7rem',
                color: corSetor,
                margin: 0,
                marginTop: '3px',
                lineHeight: 1,
                fontWeight: 600,
              }}>
                {usuario.setor}
              </p>
            )}
          </div>
          <button
            onClick={logout}
            style={{
              background: 'transparent', border: '1px solid #222', borderRadius: '7px',
              padding: '6px 14px', color: '#555', fontSize: '0.75rem', cursor: 'pointer',
              fontFamily: "'DM Sans', sans-serif", letterSpacing: '0.04em',
              transition: 'border-color 0.15s, color 0.15s',
            }}
            onMouseEnter={(e) => { e.currentTarget.style.borderColor = '#e03333'; e.currentTarget.style.color = '#e03333'; }}
            onMouseLeave={(e) => { e.currentTarget.style.borderColor = '#222'; e.currentTarget.style.color = '#555'; }}
          >
            Sair
          </button>
        </div>
      </header>

      {/* ── Conteúdo central ────────────────────────── */}
      <main style={{
        flex: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '2rem',
      }}>
        <div style={{ width: '100%', maxWidth: '480px' }}>

          {/* Título + setor */}
          <div style={{ marginBottom: '2rem', textAlign: 'center' }}>
            <h1 style={{
              fontFamily: "'Bebas Neue', cursive",
              fontSize: '2.8rem',
              letterSpacing: '0.1em',
              color: '#e0e0e0',
              margin: 0,
              lineHeight: 1,
            }}>
              BIPAGEM
            </h1>
            {labelSetor && (
              <div style={{ display: 'inline-flex', alignItems: 'center', gap: '7px', marginTop: '0.75rem' }}>
                <span style={{ width: '8px', height: '8px', borderRadius: '50%', background: corSetor, display: 'inline-block', flexShrink: 0 }} />
                <span style={{ fontFamily: "'DM Sans', sans-serif", fontSize: '0.8rem', color: corSetor, fontWeight: 600, letterSpacing: '0.06em', textTransform: 'uppercase' }}>
                  {labelSetor}
                </span>
              </div>
            )}
          </div>

          {/* ── Campo de número ──────────────────────── */}
          <form onSubmit={buscarItem}>
            <div style={{ position: 'relative' }}>
              <div style={{
                position: 'absolute',
                left: '16px',
                top: '50%',
                transform: 'translateY(-50%)',
                color: '#444',
                pointerEvents: 'none',
              }}>
                <IconeScan />
              </div>
              <input
                ref={inputRef}
                type="text"
                value={numero}
                onChange={(e) => {
                  setNumero(e.target.value);
                  if (fase !== 'idle' && fase !== 'buscando' && fase !== 'bipando') {
                    setItem(null);
                    setFase('idle');
                    setMensagem('');
                    setErroDetalhes(null);
                    setEscolhendoTipo(false);
                    setTipoSelecionado(null);
                  }
                }}
                placeholder="Número do item..."
                disabled={ocupado || fase === 'sucesso'}
                style={{
                  width: '100%',
                  background: '#181818',
                  border: '1px solid #2a2a2a',
                  borderRadius: '10px',
                  padding: '1rem 1rem 1rem 52px',
                  color: '#e8e8e8',
                  fontSize: '1.1rem',
                  fontFamily: "'JetBrains Mono', monospace",
                  outline: 'none',
                  letterSpacing: '0.05em',
                  boxSizing: 'border-box',
                  transition: 'border-color 0.18s',
                  opacity: (ocupado || fase === 'sucesso') ? 0.5 : 1,
                }}
                onFocus={(e) => e.target.style.borderColor = '#f0a500'}
                onBlur={(e) => e.target.style.borderColor = '#2a2a2a'}
              />
            </div>

            {/* Botão de busca — só aparece se não tiver item ainda */}
            {fase === 'idle' && numero.trim() && (
              <button
                type="submit"
                style={{
                  width: '100%',
                  marginTop: '10px',
                  background: '#1e1e1e',
                  border: '1px solid #2a2a2a',
                  borderRadius: '8px',
                  padding: '0.7rem',
                  color: '#888',
                  fontSize: '0.8rem',
                  fontFamily: "'DM Sans', sans-serif",
                  letterSpacing: '0.06em',
                  cursor: 'pointer',
                  transition: 'all 0.15s',
                }}
                onMouseEnter={(e) => { e.currentTarget.style.borderColor = '#f0a500'; e.currentTarget.style.color = '#f0a500'; }}
                onMouseLeave={(e) => { e.currentTarget.style.borderColor = '#2a2a2a'; e.currentTarget.style.color = '#888'; }}
              >
                Buscar item — ou pressione Enter
              </button>
            )}
          </form>

          {/* ── Buscando ─────────────────────────────── */}
          {fase === 'buscando' && (
            <div style={{ textAlign: 'center', marginTop: '2rem', color: '#444', fontFamily: "'DM Sans', sans-serif", fontSize: '0.85rem' }}>
              Buscando...
            </div>
          )}

          {/* ── Item encontrado ───────────────────────── */}
          {fase === 'pronto' && item && (
            <div style={{ marginTop: '1.25rem' }}>
              <div style={{
                background: '#141414',
                border: '1px solid #1e1e1e',
                borderLeft: `4px solid ${COR_SETOR[item.setor_atual] || '#888'}`,
                borderRadius: '10px',
                padding: '1rem 1.25rem',
                marginBottom: '1rem',
              }}>
                <p style={{
                  fontFamily: "'JetBrains Mono', monospace",
                  fontSize: '0.72rem',
                  color: '#f0a500',
                  fontWeight: 700,
                  margin: 0,
                  marginBottom: '6px',
                  letterSpacing: '0.04em',
                }}>
                  {item.numero}
                </p>
                <p style={{
                  fontFamily: "'DM Sans', sans-serif",
                  fontSize: '0.95rem',
                  color: '#e0e0e0',
                  fontWeight: 500,
                  margin: 0,
                  marginBottom: '10px',
                  lineHeight: 1.35,
                }}>
                  {item.descricao}
                </p>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap' }}>
                  <span style={{
                    background: (COR_SETOR[item.setor_atual] || '#888') + '20',
                    color: COR_SETOR[item.setor_atual] || '#888',
                    borderRadius: '20px',
                    padding: '3px 10px',
                    fontSize: '0.72rem',
                    fontWeight: 700,
                    fontFamily: "'DM Sans', sans-serif",
                  }}>
                    {item.setor_atual}
                  </span>
                  <span style={{ color: '#333', fontSize: '0.8rem' }}>·</span>
                  <span style={{ fontFamily: "'DM Sans', sans-serif", fontSize: '0.75rem', color: '#555' }}>
                    O.S <span style={{ fontFamily: "'JetBrains Mono', monospace", color: '#666' }}>{item.ordem_numero}</span>
                  </span>
                  <span style={{ color: '#333', fontSize: '0.8rem' }}>·</span>
                  <span style={{ fontFamily: "'DM Sans', sans-serif", fontSize: '0.75rem', color: '#555' }}>{item.cliente}</span>
                </div>
              </div>

              {/* Botões de ação */}
              {escolhendoProximoSetorFora ? (
                <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                  <p style={{ fontFamily: "'DM Sans', sans-serif", fontSize: '0.82rem', color: '#666', margin: '0 0 4px 0' }}>
                    Escolha o próximo setor:
                  </p>
                  {['Acabamento', 'Expedição'].map((setor) => {
                    const cor = COR_SETOR[setor];
                    return (
                      <button
                        key={setor}
                        onClick={() => { setSetorForaSelecionado(setor); setEscolhendoProximoSetorFora(false); bipar('saida', null, setor); }}
                        style={{
                          background: cor + '18', border: `1px solid ${cor}55`,
                          borderRadius: '9px', padding: '0.85rem 1rem',
                          color: cor, fontFamily: "'Bebas Neue', cursive",
                          fontSize: '1.1rem', letterSpacing: '0.08em',
                          cursor: 'pointer', textAlign: 'left', transition: 'all 0.15s',
                        }}
                        onMouseEnter={(e) => { e.currentTarget.style.background = cor + '30'; e.currentTarget.style.borderColor = cor; }}
                        onMouseLeave={(e) => { e.currentTarget.style.background = cor + '18'; e.currentTarget.style.borderColor = cor + '55'; }}
                      >
                        {setor}
                      </button>
                    );
                  })}
                  <button
                    onClick={resetar}
                    style={{ background: 'transparent', border: 'none', color: '#444', fontSize: '0.78rem', fontFamily: "'DM Sans', sans-serif", cursor: 'pointer', padding: '0.4rem', marginTop: '2px' }}
                    onMouseEnter={(e) => e.currentTarget.style.color = '#888'}
                    onMouseLeave={(e) => e.currentTarget.style.color = '#444'}
                  >
                    Cancelar
                  </button>
                </div>
              ) : escolhendoTipo ? (
                <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                  <p style={{ fontFamily: "'DM Sans', sans-serif", fontSize: '0.82rem', color: '#666', margin: '0 0 4px 0' }}>
                    Escolha o tipo de impressão:
                  </p>
                  {TIPOS_IMPRESSAO.map((tipo) => {
                    const cor = COR_SETOR[tipo];
                    return (
                      <button
                        key={tipo}
                        onClick={() => { setTipoSelecionado(tipo); setDestinoDireto(null); setEscolhendoTipo(false); bipar('saida', tipo); }}
                        style={{
                          background: cor + '18', border: `1px solid ${cor}55`,
                          borderRadius: '9px', padding: '0.85rem 1rem',
                          color: cor, fontFamily: "'Bebas Neue', cursive",
                          fontSize: '1.1rem', letterSpacing: '0.08em',
                          cursor: 'pointer', textAlign: 'left', transition: 'all 0.15s',
                        }}
                        onMouseEnter={(e) => { e.currentTarget.style.background = cor + '30'; e.currentTarget.style.borderColor = cor; }}
                        onMouseLeave={(e) => { e.currentTarget.style.background = cor + '18'; e.currentTarget.style.borderColor = cor + '55'; }}
                      >
                        {tipo}
                      </button>
                    );
                  })}
                  <div style={{ borderTop: '1px solid #222', margin: '4px 0' }} />
                  {[
                    { label: 'Para Expedição', dest: 'Expedição' },
                  ].map(({ label, dest }) => {
                    const cor = COR_SETOR[dest];
                    return (
                      <button
                        key={dest}
                        onClick={() => { setDestinoDireto(dest); setTipoSelecionado(null); setEscolhendoTipo(false); bipar('saida', null, null, dest); }}
                        style={{
                          background: cor + '18', border: `1px solid ${cor}55`,
                          borderRadius: '9px', padding: '0.85rem 1rem',
                          color: cor, fontFamily: "'Bebas Neue', cursive",
                          fontSize: '1.1rem', letterSpacing: '0.08em',
                          cursor: 'pointer', textAlign: 'left', transition: 'all 0.15s',
                        }}
                        onMouseEnter={(e) => { e.currentTarget.style.background = cor + '30'; e.currentTarget.style.borderColor = cor; }}
                        onMouseLeave={(e) => { e.currentTarget.style.background = cor + '18'; e.currentTarget.style.borderColor = cor + '55'; }}
                      >
                        {label}
                      </button>
                    );
                  })}
                  <button
                    onClick={resetar}
                    style={{ background: 'transparent', border: 'none', color: '#444', fontSize: '0.78rem', fontFamily: "'DM Sans', sans-serif", cursor: 'pointer', padding: '0.4rem', marginTop: '2px' }}
                    onMouseEnter={(e) => e.currentTarget.style.color = '#888'}
                    onMouseLeave={(e) => e.currentTarget.style.color = '#444'}
                  >
                    Cancelar
                  </button>
                </div>
              ) : (
                <>
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px' }}>
                    <button
                      onClick={() => bipar('entrada')}
                      style={{
                        background: '#1a2a1a', border: '1px solid #2a4a2a', borderRadius: '9px',
                        padding: '0.9rem', color: '#4ade80',
                        fontFamily: "'Bebas Neue', cursive", fontSize: '1.2rem', letterSpacing: '0.1em',
                        cursor: 'pointer', transition: 'all 0.15s',
                      }}
                      onMouseEnter={(e) => { e.currentTarget.style.background = '#1f361f'; e.currentTarget.style.borderColor = '#4ade80'; }}
                      onMouseLeave={(e) => { e.currentTarget.style.background = '#1a2a1a'; e.currentTarget.style.borderColor = '#2a4a2a'; }}
                    >
                      ENTRADA
                    </button>
                    <button
                      onClick={() => {
                        if (item.setor_atual === 'Arte Finalista') {
                          setEscolhendoTipo(true);
                        } else if (item.setor_atual === 'Impressão Fora') {
                          setEscolhendoProximoSetorFora(true);
                        } else {
                          bipar('saida');
                        }
                      }}
                      style={{
                        background: '#f0a500', border: '1px solid #f0a500', borderRadius: '9px',
                        padding: '0.9rem', color: '#0d0d0d',
                        fontFamily: "'Bebas Neue', cursive", fontSize: '1.2rem', letterSpacing: '0.1em',
                        cursor: 'pointer', transition: 'all 0.15s',
                      }}
                      onMouseEnter={(e) => { e.currentTarget.style.background = '#d9940a'; e.currentTarget.style.borderColor = '#d9940a'; }}
                      onMouseLeave={(e) => { e.currentTarget.style.background = '#f0a500'; e.currentTarget.style.borderColor = '#f0a500'; }}
                    >
                      SAÍDA
                    </button>
                  </div>
                  <button
                    onClick={resetar}
                    style={{
                      width: '100%', marginTop: '10px', background: 'transparent', border: 'none',
                      color: '#444', fontSize: '0.78rem', fontFamily: "'DM Sans', sans-serif",
                      cursor: 'pointer', padding: '0.5rem', transition: 'color 0.15s',
                    }}
                    onMouseEnter={(e) => e.currentTarget.style.color = '#888'}
                    onMouseLeave={(e) => e.currentTarget.style.color = '#444'}
                  >
                    Cancelar — bipar outro item
                  </button>
                </>
              )}
            </div>
          )}

          {/* ── Bipando ──────────────────────────────── */}
          {fase === 'bipando' && (
            <div style={{ textAlign: 'center', marginTop: '2rem', color: '#444', fontFamily: "'DM Sans', sans-serif", fontSize: '0.85rem' }}>
              Registrando {ultimaAcao}...
            </div>
          )}

          {/* ── Sucesso ──────────────────────────────── */}
          {fase === 'sucesso' && (
            <div style={{
              marginTop: '1.25rem',
              background: 'rgba(74,222,128,0.07)',
              border: '1px solid rgba(74,222,128,0.2)',
              borderRadius: '10px',
              padding: '1.25rem',
              display: 'flex',
              alignItems: 'center',
              gap: '14px',
            }}>
              <div style={{
                width: '42px', height: '42px', borderRadius: '50%',
                background: 'rgba(74,222,128,0.12)',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                color: '#4ade80', flexShrink: 0,
              }}>
                <IconeCheck />
              </div>
              <p style={{
                fontFamily: "'DM Sans', sans-serif",
                fontSize: '0.9rem',
                color: '#4ade80',
                margin: 0,
                lineHeight: 1.4,
              }}>
                {mensagem}
              </p>
            </div>
          )}

          {/* ── Erro ─────────────────────────────────── */}
          {fase === 'erro' && (
            erroDetalhes?.setoresPermitidos ? (
              <div style={{ marginTop: '1.25rem', borderRadius: '12px', overflow: 'hidden', border: '1px solid rgba(224,51,51,0.25)' }}>
                {/* Cabeçalho */}
                <div style={{ background: 'rgba(224,51,51,0.12)', padding: '12px 16px', display: 'flex', alignItems: 'center', gap: '10px', borderBottom: '1px solid rgba(224,51,51,0.2)' }}>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#e05555" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0 }}>
                    <rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/>
                  </svg>
                  <span style={{ fontFamily: "'DM Sans', sans-serif", fontSize: '0.88rem', color: '#e05555', fontWeight: 700 }}>
                    Sem acesso — item em <span style={{ color: COR_SETOR[erroDetalhes.setorBloqueado] || '#e05555' }}>{erroDetalhes.setorBloqueado}</span>
                  </span>
                </div>
                {/* Setores permitidos */}
                <div style={{ background: '#111', padding: '12px 16px' }}>
                  <p style={{ fontFamily: "'DM Sans', sans-serif", fontSize: '0.72rem', color: '#555', textTransform: 'uppercase', letterSpacing: '0.08em', margin: '0 0 10px 0' }}>
                    Seus setores
                  </p>
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: '7px' }}>
                    {erroDetalhes.setoresPermitidos.map((s) => {
                      const cor = COR_SETOR[s] || '#888';
                      return (
                        <span key={s} style={{
                          fontFamily: "'DM Sans', sans-serif", fontSize: '0.78rem', fontWeight: 700,
                          color: cor, background: cor + '18', border: `1px solid ${cor}40`,
                          borderRadius: '20px', padding: '3px 10px',
                        }}>
                          {s}
                        </span>
                      );
                    })}
                  </div>
                </div>
              </div>
            ) : erroDetalhes?.itensPendentes ? (
              <div style={{ marginTop: '1.25rem', borderRadius: '12px', overflow: 'hidden', border: '1px solid rgba(224,51,51,0.25)' }}>
                <div style={{ background: 'rgba(224,51,51,0.12)', padding: '12px 16px', borderBottom: '1px solid rgba(224,51,51,0.2)' }}>
                  <p style={{ fontFamily: "'DM Sans', sans-serif", fontSize: '0.88rem', color: '#e05555', fontWeight: 700, margin: 0 }}>
                    Despacho bloqueado
                  </p>
                  <p style={{ fontFamily: "'DM Sans', sans-serif", fontSize: '0.78rem', color: '#888', margin: '3px 0 0 0' }}>
                    {erroDetalhes.itensPendentes.length} {erroDetalhes.itensPendentes.length === 1 ? 'item ainda não está' : 'itens ainda não estão'} na Expedição
                  </p>
                </div>
                <div style={{ background: '#111', padding: '12px 16px', display: 'flex', flexDirection: 'column', gap: '8px' }}>
                  {erroDetalhes.itensPendentes.map((ip) => {
                    const cor = COR_SETOR[ip.setor_atual] || '#888';
                    return (
                      <div key={ip.numero} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '10px' }}>
                        <span style={{ fontFamily: "'JetBrains Mono', monospace", fontSize: '0.78rem', color: '#aaa', flexShrink: 0 }}>{ip.numero}</span>
                        <span style={{ fontFamily: "'DM Sans', sans-serif", fontSize: '0.78rem', color: '#666', flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{ip.descricao}</span>
                        <span style={{ fontFamily: "'DM Sans', sans-serif", fontSize: '0.72rem', fontWeight: 700, color: cor, background: cor + '18', border: `1px solid ${cor}40`, borderRadius: '20px', padding: '2px 9px', flexShrink: 0 }}>{ip.setor_atual}</span>
                      </div>
                    );
                  })}
                </div>
              </div>
            ) : (
              <div style={{
                marginTop: '1.25rem', background: 'rgba(224,51,51,0.07)',
                border: '1px solid rgba(224,51,51,0.2)', borderRadius: '10px',
                padding: '1rem 1.25rem',
              }}>
                <p style={{ fontFamily: "'DM Sans', sans-serif", fontSize: '0.88rem', color: '#e05555', margin: 0, lineHeight: 1.45 }}>
                  {mensagem}
                </p>
              </div>
            )
          )}
        </div>
      </main>
    </div>
  );
}
